import { useEffect, useMemo, useState } from "react";
import { FormField, QueryItem } from "../../types/Query";
import queryFieldControllerApis from "../../api/queryFieldControllerApis";

export function useQueryForm(schoolId: string) {
  const [formFields, setFormFields] = useState<FormField[]>([]);
  const [formData, setFormData] = useState<QueryItem>({} as QueryItem);

  const resetForm = () => {
    setFormData({} as QueryItem);
  };

  useEffect(() => {
    queryFieldControllerApis.getFormFields(schoolId).then((res) => {
      if (res?.data) setFormFields(res.data);
    });
  }, [schoolId]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value, type, checked, files } = e.target as any;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files?.[0] : value,
    }));
  };

  const isFormValid = useMemo(() => {
    if (!formFields.length) return false;

    return formFields.every((field) => {
      if (!field.isFieldRequired) return true;

      const value = formData[field.fieldAbbr];

      if (field.fieldType === "IMAGE") {
        return typeof value === "string" && value.length > 0;
      }

      return value !== undefined && value !== "";
    });
  }, [formFields, formData]);

  return {
    formFields,
    formData,
    setFormData,
    handleChange,
    isFormValid,
    resetForm
  };
}
